export default __webpack_public_path__ + "static/media/Cubs.bb54456f.svg";